<template>
  <div class="bg-white p-6">
    <!-- <div class="">
      <div class="bg-white flex justify-between">
        <div class="flex">
          <div class="border-b-4 px-10 py-2 mx-4">
            <p class="text-primary font-semibold">Design</p>
          </div>
          <div class="px-10 py-2 mx-4">
            <p class="font-semibold">Test</p>
          </div>
          <div class="px-10 py-2 mx-4">
            <p class="font-semibold">Dashboard</p>
          </div>
          <div class=" px-10 py-2 mx-4">
            <p class="font-semibold">Maps</p>
          </div>
        </div>
        <div class="flex m-1">
          <base-button
            filled
            type="primary"
            class="flex px-4 py-0"
            @click="addBanner"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Run Test
          </base-button>
          <base-button
            filled
            type="primary"
            class="flex px-4 py-0"
            @click="addBanner"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Share
          </base-button>
        </div>
      </div>
      <hr class="w3 w-full" />
    </div> -->
    <div class="bg-f4f5f6 p-4">
      <div class="flex w-1/2">
        <div class="mx-1 w-1/2">
          <p class="font-semibold text-md">Search</p>
          <div class="input-group my-2">
            <input
              type="text"
              class="form-control h-10"
              placeholder="Search here..."
              aria-label="Example text with button addon"
              aria-describedby="button-addon1"
            />
          </div>
        </div>
        <div class="mx-1 w-1/4">
          <p class="font-semibold text-md">Platform</p>
          <div class="my-2">
            <b-form-select
              v-model="selected"
              :options="options"
              class="h-10"
            ></b-form-select>
          </div>
        </div>
        <div class="mx-1 w-1/4">
          <p class="font-semibold text-md">Version</p>
          <div class="my-2">
            <b-form-select
              v-model="selected2"
              :options="options2"
              class="h-10"
            ></b-form-select>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="flex py-4">
        <div class="w-1/5 px-4">
          <img src="./img/2b.png" alt="" class="w-full border-2" />
          <p class="mt-1 text-center font-semibold text-sm">Homepage</p>
        </div>
        <div class="w-1/5 px-4">
          <img src="./img/1b.png" alt="" class="w-full border-2" />
          <p class="mt-1 text-center font-semibold text-sm">Productpage</p>
        </div>
        <div class="w-1/5 px-4">
          <img src="./img/re.png" alt="" class="w-full border-2" />
          <p class="mt-1 text-center font-semibold text-sm">Review</p>
        </div>
        <div class="w-1/5 px-4">
          <img src="./img/cart.png" alt="" class="w-full border-2" />
          <p class="mt-1 text-center font-semibold text-sm">Cart</p>
        </div>
        <div class="w-1/5 px-4">
          <img src="./img/map.png" alt="" class="w-full border-2" />
          <p class="mt-1 text-center font-semibold text-sm">Tracking</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
hr.w3 {
  border: 1px solid rgb(223, 223, 223);
}
.border-b-4 {
  border-bottom-width: 4px;
  border-bottom-color: #830c81;
}
</style>
<script>
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: "Mobile" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: { C: "3PO" }, text: "This is an option with object value" },
        { value: "d", text: "This one is disabled", disabled: true }
      ],
      selected2: null,
      options2: [
        { value: null, text: "Select Version" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: { C: "3PO" }, text: "This is an option with object value" },
        { value: "d", text: "This one is disabled", disabled: true }
      ]
    };
  }
};
</script>
